<template>
    <div class="normal-order-info-icons" :style="inDetails ? 'width: fit-content;' : ''">
        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasProp(product,'psychotropic')">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-alert</v-icon>
            </template>
            <span>{{ $t('productInfo.psychotropic') }}</span>
        </v-tooltip>

        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="showAirCargoIcon">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-airplane-off </v-icon>
            </template>
            <span>{{ $t('productInfo.noAir') }}</span>
        </v-tooltip>
        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="showBoatIcon">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-ferry </v-icon>
            </template>
            <span>{{ $t('productInfo.boat') }}</span>
        </v-tooltip>

        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasProp(product,'cold_storage')">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-snowflake</v-icon>
            </template>
            <span>{{ $t('productInfo.coldStorage') }}</span>
        </v-tooltip>

        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasProp(product,'serializable')">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-barcode</v-icon>
            </template>
            <span>{{ $t('productInfo.serializable') }}</span>
        </v-tooltip>

        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="hasProp(product,'orderable')">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-sync-off</v-icon>
            </template>
            <span>{{ $t('productInfo.orderable') }}</span>
        </v-tooltip>

        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="inDetails && hasProp(product,'amount_per_package')">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-archive</v-icon>
            </template>
            <span>{{ $t('productInfo.perPackage', { n: product.amount_per_package }) }}</span>
        </v-tooltip>

        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="inDetails && hasProp(product,'amount_per_pallet')">
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="black" v-on="on" v-bind="attrs">mdi-shipping-pallet</v-icon>
            </template>
            <span>{{ $t('productInfo.perPallet', { n: product.amount_per_pallet }) }}</span>
        </v-tooltip>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';

export default {
    props: {
        product: Object,
        inDetails: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapStores(useBranchStore),

        showAirCargoIcon() {
            //return this.branchStore.branch?.zone === 'ILHAS' && this.product.cold_storage && !this.product.flammable;
            return this.branchStore.branch?.zone === 'ILHAS' && !this.product.air_cargo && this.product.flammable;
        },
        showBoatIcon(){
            return this.branchStore.branch?.zone === 'ILHAS' && this.product.air_cargo==2;
        }
    },
    methods:{
        hasProp(product,prop){
            if(_.has(product,prop)){
                if(product[prop]){
                    return true
                }
            }
            return false
        }
    }
};
</script>

<style>
.normal-order-info-icons {
    text-align: left !important;
}

.normal-order-info-icons > i {
    left: 15%;
}
</style>
